import { Link } from 'gatsby'
import React from 'react'
import * as s from './Navbar.module.css'
import logo from '../../../images/logo.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft} from '@fortawesome/free-solid-svg-icons'
import { navigate } from "gatsby";
export const Navbar = () => {
    return (
        <div className={s.wrapper}>
            <Link type='button'  className={s.linkContainer} to='/'>
                <FontAwesomeIcon icon={faChevronLeft} className={s.prevIcon}/>
                <p>zurück</p>
            </Link>
            <Link to='/'>
            <img src={logo} className={s.logo} alt="logo" />
            </Link>
        </div>
    )
}
